import React from 'react';
import PropTypes from 'prop-types';

const EventTitle = ({
  info, pltDes, eachWay, meetingDesc,
}) => (
  <>
    <p className="upcoming-races-odd-title">{meetingDesc}</p>
    <p className="upcoming-races-odd-period">
      {`${info}${eachWay ? ` - ${pltDes}` : ''}`}
    </p>
  </>
);

EventTitle.propTypes = {
  info: PropTypes.string.isRequired,
  pltDes: PropTypes.string.isRequired,
  eachWay: PropTypes.bool.isRequired,
  meetingDesc: PropTypes.string.isRequired,
};

export default EventTitle;
